export const UI_TOGGLE_SHOW_SHORTCUTS = 'UI_TOGGLE_SHOW_SHORTCUTS';